import apiClient from '@/services/axios'

export async function del(dto) {
    var response = await apiClient.delete(process.env.VUE_APP_CRM_API_BASE_URL + `/EngageEmail/syncStatus?venueId=${dto.venueId}&syncEmail=${dto.syncEmail}`)
    if (response) {
        return response.data
    }

    throw new Error('Unable to delete sync venue')
}